/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum UsageCycleUnit {
    Day = 'Day',
    Week = 'Week',
    Month = 'Month',
    Year = 'Year',
}
